import { Subject } from "rxjs";

const subject = new Subject();

export const dataService = {
  publish: (data) => subject.next(data),
  getObservable: () => subject.asObservable(),
};
